/*
 * @Date: 2025-02-10 10:10:58
 * @createEditors: ciro（王成宇）
 * @LastEditTime: 2025-02-10 10:11:05
 * @FilePath: \jyh5\src\utils\ScrollSelect.js
 * @Description: 
 * @修改人-修改时间-修改内容: 如本文件有更新，请修改本行，如多次更新，请换行复制本行进行新增行
 */
const ScrollSelect = {
    install(Vue) {
      // 注册全局组件
      Vue.component('scroll-select', {
        props: {
          options: {
            type: Array,
            required: true,
          },
          value: {
            type: [String, Number],
            default: '',
          },
        },
        data() {
          return {
            selectedIndex: 0,
          };
        },
        mounted() {
          this.scrollToSelected();
          this.$el.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
          this.$el.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
          handleScroll() {
            const container = this.$el;
            const itemHeight = container.querySelector('.scroll-item').clientHeight;
            const scrollTop = container.scrollTop;
            const index = Math.round(scrollTop / itemHeight);
            if (index !== this.selectedIndex) {
              this.selectedIndex = index;
              this.$emit('input', this.options[index]);
            }
          },
          scrollToSelected() {
            const container = this.$el;
            const itemHeight = container.querySelector('.scroll-item').clientHeight;
            const index = this.options.indexOf(this.value);
            if (index >= 0) {
              container.scrollTop = index * itemHeight;
              this.selectedIndex = index;
            }
          },
        },
        template: `
   <div class="scroll-container">
   <div
              v-for="(option, index) in options"
              :key="index"
              class="scroll-item"
              :class="{ active: selectedIndex === index }"
   >
              {{ option }}
   </div>
   </div>
        `,
      });
    },
   };
   export default ScrollSelect;


// WEBPACK FOOTER //
// ./src/utils/ScrollSelect.js